import { Icon } from '~/components/icon'
import type { InputSelectProps } from '../../types'

export interface InputSelectLeftIconProps {
  icon: InputSelectProps['leftIcon']
  size?: InputSelectProps['size']
  disabled?: boolean
  readonly?: boolean
}

export const InputSelectLeftIcon: React.FC<InputSelectLeftIconProps> = ({
  icon,
  size = 'md',
  disabled,
  readonly,
}) => {
  return (
    <Icon
      size={size === 'md' ? 'extra-small' : 'small'}
      symbol={icon}
      color={
        disabled
          ? 'colorTextNeutralDisabled'
          : readonly
            ? 'colorTextNeutralReadonly'
            : 'colorTextNeutralDefault'
      }
      data-testid={icon}
    />
  )
}
